import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { type ReactNode } from 'react';
import { Card } from './card';
import styles from './member-card.module.scss';
export type MemberCardProps = {
  badge?: ReactNode;
  className?: string;
  companyName?: string;
  designations?: string;
  imageAlt?: string;
  imageSrc?: string;
  isClickable?: boolean;
  levelLabel?: string;
  name: string;
  placeholder?: ReactNode;
};
export const MemberCard = t0 => {
  const $ = _c(29);
  const {
    badge,
    className,
    companyName,
    designations,
    imageAlt: t1,
    imageSrc,
    isClickable: t2,
    levelLabel,
    name,
    placeholder
  } = t0;
  const imageAlt = t1 === undefined ? "" : t1;
  const isClickable = t2 === undefined ? true : t2;
  let t3;
  if ($[0] !== className) {
    t3 = classNames(styles["member-card"], className);
    $[0] = className;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== imageAlt || $[3] !== imageSrc || $[4] !== placeholder) {
    t4 = imageSrc ? <img alt={imageAlt} className={styles["member-card__photo"]} role={imageAlt ? undefined : "presentation"} src={imageSrc} /> : placeholder;
    $[2] = imageAlt;
    $[3] = imageSrc;
    $[4] = placeholder;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== badge) {
    t5 = badge && <div className={styles["member-card__badge"]}>{badge}</div>;
    $[6] = badge;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <div className={styles["member-card__photo-container"]}>{t4}{t5}</div>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== name) {
    t7 = <div className={styles["member-card__name"]}>{name}</div>;
    $[11] = name;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== designations) {
    t8 = designations && <div className={styles["member-card__designations"]}>{designations}</div>;
    $[13] = designations;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== levelLabel) {
    t9 = levelLabel && <div className={classNames(styles["member-card__level-label"], styles["member-card__level-label--sr-only"])}>{levelLabel}</div>;
    $[15] = levelLabel;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== companyName) {
    t10 = companyName && <div className={styles["member-card__company-name"]}>{companyName}</div>;
    $[17] = companyName;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t7 || $[21] !== t8 || $[22] !== t9) {
    t11 = <div className={styles["member-card__details"]}>{t7}{t8}{t9}{t10}</div>;
    $[19] = t10;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== isClickable || $[25] !== t11 || $[26] !== t3 || $[27] !== t6) {
    t12 = <Card className={t3} hasSmallRadius={true} isClickable={isClickable}>{t6}{t11}</Card>;
    $[24] = isClickable;
    $[25] = t11;
    $[26] = t3;
    $[27] = t6;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
};